export default {
  ConvertToForgotPwd(_forgotPwd) {
    let forgotPwd = {
      actionDateTime: _forgotPwd.actionDateTime,
      forgotPwdCode: _forgotPwd.forgotPwdCode,
      id: _forgotPwd.id,
      status: _forgotPwd.status,
      userName: _forgotPwd.userName,
    };

    return forgotPwd;
  },
  ConvertToUserDetailList(userDetailRawList) {
    let userDetailList = [];
    if (userDetailRawList && userDetailRawList.length > 0) {
      for (let userDetailRaw of userDetailRawList) {
        userDetailList.push({
          userId: userDetailRaw.userId,
          userEmail: userDetailRaw.userEmail,
          userType: userDetailRaw.userType,
          signatureUrl: userDetailRaw.signatureUrl,
          displayName: userDetailRaw.displayName,
          accountingFirmId: userDetailRaw.accountingFirmId,
          phone: userDetailRaw.phone,
          pictureUrl: userDetailRaw.pictureUrl,
          userName: userDetailRaw.userName,
          firstName:userDetailRaw.firstName,
          lastName:userDetailRaw.lastName
        });
      }
    }
    return userDetailList;
  },
};
